import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/Main.vue';
import ClubView from '@/components/Club/ClubView.vue';
/*import FeedsNews from '@/components/Feeds/FeedsNews.vue';
import Feeds from '@/views/Feeds.vue';
import Youtube from '@/components/Feeds/Youtube.vue';
import Facebook from '@/components/Feeds/Facebook.vue';
import Instagram from '@/components/Feeds/Instagram.vue';*/
import MatchList from '@/components/Match/MatchList.vue';
import MatchView from '@/components/Match/MatchView.vue';
import MatchDetail from '@/components/Match/MatchDetail.vue';
import FansLayout from '@/components/Fans/FansLayout.vue';
import FansView from '@/components/Fans/FansView.vue';
import FansDetail from '@/components/Fans/FansDetail.vue';
import TeamRanking from '@/components/Match/TeamRanking.vue';
import PlayerRanking from '@/components/Match/PlayerRanking.vue';
import Login from '@/components/Auth/Login.vue';
import Join from '@/components/Auth/Join.vue';
import JoinAgreeBox from '@/components/Auth/JoinAgreeBox.vue';
import JoinUserCitation from '@/components/Auth/JoinUserCitation.vue';
import JoinForm from '@/components/Auth/JoinForm.vue';
import FindPassword from '@/components/Auth/FindPassword.vue';
import FindId from '@/components/Auth/FindId.vue';
import privacy from '@/components/Auth/Privacy.vue';
import TicketView from '@/components/Ticket/TicketView.vue';
import TicketReservations from '@/components/Ticket/TicketReservations.vue';
import TicketSeasonInfo from '@/components/Ticket/TicketSeasonInfo.vue';
import TicketSeason from '@/components/Ticket/TicketSeason.vue';
import TicketSeasonList from '@/components/Ticket/TicketSeasonList.vue';
import TicketSeasonRegister from '@/components/Ticket/TicketSeasonRegister.vue';
import PlayerView from '@/components/Player/PlayerView.vue';
import PlayerTeam from '@/components/Player/PlayerTeam.vue';
import PlayerStaff from '@/components/Player/PlayerStaff.vue';
import PlayerSchedule from '@/components/Player/PlayerSchedule.vue';
import PlayerDetail from '@/components/Player/PlayerDetail.vue';
import YouthView from '@/components/Youth/YouthView.vue';
import LittleDragons from '@/components/Youth/LittleDragons.vue';
import YouthListView from '@/components/Youth/YouthListView.vue';
import MyPageView from '@/components/MyPage/MyPageView.vue';
import MyPage from '@/components/MyPage/MyPage.vue';
import MyInfo from '@/components/MyPage/MyInfo.vue';
import ContactUs from '@/components/MyPage/ContactUs.vue';
import Withdraw from '@/components/MyPage/Withdraw.vue';
import pageNotFound from "@/components/Common/pageNotFound.vue";
import ContactUsWrite from '@/components/MyPage/ContactUsWrite.vue';
import ServicePolicy from '@/components/Auth/ServicePolicy.vue';
import AnniversaryLogo from '@/components/Club/AnniversaryLogo.vue';
import EmblemView from '@/components/Club/EmblemView.vue';
import Mascot from "@/components/Club/Mascot.vue"
import Stadium from '@/components/Club/Stadium.vue';
import Sponsor from '@/components/Club/Sponsor.vue';
import Csr from '@/components/Club/Csr.vue';
import store from '@/store';
import Seats from "@/components/Ticket/Seats.vue"
import HistoryView from '@/components/Club/HistoryView.vue';
import ProgramGuide from '@/components/Youth/ProgramGuide.vue';
import TrainingTimetable from '@/components/Youth/TrainingTimetable.vue';
import ApplicationJoinClub from '@/components/Youth/ApplicationJoinClub.vue';
import UniformGuide from '@/components/Youth/UniformGuide.vue';
import AcademyRules from '@/components/Youth/AcademyRules.vue';
import AcademyStaff from '@/components/Youth/AcademyStaff.vue';
import Local from '@/components/Club/Local';
import DragonsFamily from '@/components/Club/DragonsFamily';
import ReservationTest from '@/components/Ticket/ReservationTest';

Vue.use(VueRouter);

// 현재 경로와 이동 경로가 같은 경우
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {
    return window.location.reload();
  })
};

const rejectAuthUser = (to, from, next) => {
  const token = JSON.parse(localStorage.getItem('token'));
  if( token && token.access ) {
    next('/');
  }else {
    next();
  }
};

const onlyAuthUser = (to, from, next) => {
  const token = JSON.parse(localStorage.getItem('token'));
  if(!token || !token.access) {
    alert('로그인이 필요한 서비스입니다.');
    // return router.push({name: 'login', query: {redirectUrl: to.fullPath}});
    return router.push({ name: 'login', params: { redirectUrl: to.fullPath } });
  } else {
    next();
  }
};

const routes = [
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'pageNotFound',
    component: pageNotFound
  },
  {
    path: '/',
    name: 'main',
    alias: ['/main', '/main/index'],
    component: Main
  },
  {
    path: '/club',
    name: 'club',
    component: ClubView,
    meta: {
      title: '클럽',
    },
    redirect: {
      name: '30thAnniversaryLogo'
    },
    children: [
      {
        path: 'history',
        name: 'history',
        component: HistoryView,
        meta: {
          title: '역사관'
        }
      }, /*{
        path: '30thAnniversaryLogo',
        name: '30thAnniversaryLogo',
        component: AnniversaryLogo,
        meta: {
          title: '30주년 로고'
        }
      },*/ {
        path: 'emblem',
        name: 'emblem',
        component: EmblemView,
        meta: {
          title: '엠블럼/슬로건'
        }
      },{
        path: 'mascot',
        name: 'mascot',
        component: Mascot,
        meta: {
          title: '마스코트'
        }
      }, {
        path: 'stadium',
        name: 'stadium',
        component: Stadium,
        meta: {
          title: '경기장'
        }
      }, {
        path: 'sponsor',
        name: 'sponsor',
        component: Sponsor,
        meta: {
          title: '스폰서십'
        }
      }, {
        path: 'csr',
        name: 'csr',
        component: Csr,
        meta: {
          title: '사회공헌'
        }
      }, {
        path: 'local',
        name: 'local',
        component: Local,
        meta: {
          title: '지역밀착'
        }
      }, {
        path: 'family',
        name: 'family',
        component: DragonsFamily,
        meta: {
          title: '드래곤즈 패밀리'
        }
      }
    ]
  }, {
    path: '/player',
    name: 'player',
    component: PlayerView,
    meta: {
      title: '프로',
    },
    redirect: {
      name: 'playerTeam'
    },
    children: [
      {
        path: 'team',
        name: 'playerTeam',
        component: PlayerTeam,
        meta: {
          title: '선수단 리스트',
        }
      }, {
        path: 'detail/:id',
        name : 'playerDetail',
        component: PlayerDetail,
        params: {
          id: 1
        }
      }, {
        path: 'staff',
        name: 'playerStaff',
        component: PlayerStaff,
        meta: {
          title: '코칭스태프',
        }
      }, {
        path: 'schedule',
        name: 'playerSchedule',
        component: PlayerSchedule,
        meta: {
          title: '선수단 일정',
        }
      }
    ]
  }, {
    path: '/youth',
    name: 'youth',
    component: YouthView,
    meta: {
      title: '유스',
    },
    redirect: {
      name: 'littleDragons'
    },
    children: [
      {
        path: 'littleDragons',
        name: 'littleDragons',
        component: LittleDragons,
        meta: {
          title: '리틀드래곤즈',
        },
        redirect: {
          name: 'programGuide'
        },
        children: [
          {
            path: 'programGuide',
            name: 'programGuide',
            component: ProgramGuide,
            meta: {
              title: '프로그램 안내',
            }
          }, {
            path: 'trainingTimetable',
            name: 'trainingTimetable',
            component: TrainingTimetable,
            meta: {
              title: '교육시간표',
            }
          }, {
            path: 'joinClub',
            name: 'joinClub',
            component: ApplicationJoinClub,
            // beforeEnter: onlyAuthUser,
            meta: {
              title: '입단신청',
            }
          }, {
            path: 'uniformGuide',
            name: 'uniformGuide',
            component: UniformGuide,
            // beforeEnter: onlyAuthUser,
            meta: {
              title: '유니폼 사이즈',
            }
          }, {
            path: 'academyRules',
            name: 'academyRules',
            component: AcademyRules,
            meta: {
              title: '아카데미 회칙',
            }
          }, {
            path: 'academyStaff',
            name: 'academyStaff',
            component: AcademyStaff,
            meta: {
              title: '코칭스탭',
            }
          }
        ]
      }, {
        path: 'listU18',
        name: 'listU18',
        component: YouthListView,
        meta: {
          title: 'U18',
        }
      }, {
        path: 'listU15',
        name: 'listU15',
        component: YouthListView,
        meta: {
          title: 'U15',
        }
      }, {
        path: 'listU12',
        name: 'listU12',
        component: YouthListView,
        meta: {
          title: 'U12',
        }
      }
    ]
  }, {
    path: '/ticket',
    name: 'ticket',
    component: TicketView,
    meta: {
      title: '티켓',
    },
    redirect: {
      name: 'reservations'
    },
    children: [
      {
        path: 'reservations',
        name: 'reservations',
        component: TicketReservations,
        meta: {
          title: '티켓예매',
        }
      },{
        path: 'seats',
        name: 'seats',
        component: Seats,
        meta: {
          title: '좌석안내',
        }
      }, {
        path: 'seasonInfo',
        name: 'seasonInfo',
        component: TicketSeasonInfo,
        meta: {
          title: '시즌권 소개',
        }
      }, {
        path: 'season',
        name: 'season',
        component: TicketSeason,
        meta: {
          title: '시즌권 조회/등록',
        },
        redirect: {
          name: 'seasonList'
        },
        children: [
          {
            path: 'list',
            name: 'seasonList',
            component: TicketSeasonList,
            beforeEnter: onlyAuthUser,
            meta: {
              title: '시즌권 조회',
            }
          }, {
            path: 'register',
            name: 'seasonRegister',
            component: TicketSeasonRegister,
            beforeEnter: onlyAuthUser,
            meta: {
              title: '시즌권 등록',
            }
          }
        ]
      }
    ]
  }, {
    path: '/match',
    name: 'match',
    component: MatchView,
    meta: {
      title: '경기',
    },
    redirect: {
      name: 'matchList'
    },
    children: [
      {
        path: 'list',
        name: 'matchList',
        component: MatchList,
        meta: {
          title: '경기일정/결과',
        }
      }, {
        path: 'detail/:id',
        name : 'matchDetail',
        component: MatchDetail,
        params: {
          id: 1
        }
      }, {
        path: 'team',
        name: 'teamRanking',
        component: TeamRanking,
        meta: {
          title: '팀순위',
        }
      }, {
        path: 'player',
        name: 'playerRanking',
        component: PlayerRanking,
        meta: {
          title: '선수랭킹',
        }
      }
    ]
  }, {
    path: '/fans',
    name: 'fans',
    component: FansLayout,
    meta: {
      title: '팬존',
    },
    redirect: {
      name: 'news'
    },
    children: [
      {
        path: 'news',
        name: 'news',
        component: FansView,
        meta: {
          title: '구단소식',
        }
      }, {
        path: 'notice',
        name: 'notice',
        component: FansView,
        meta: {
          title: '공지사항',
        }
      }, {
        path: 'vod',
        name: 'vod',
        component: FansView,
        meta: {
          title: '영상',
        }
      },{
        path: 'review',
        name: 'review',
        component: FansView,
        meta: {
          title: '프리뷰·리뷰',
        }
      },
      /*{
        path: 'cheer',
        name: 'cheer',
        component: FansView,
        meta: {
          title: '응원가',
        }
      },*/
      {
        path: ':page/detail/:id',
        name : 'fansDetail',
        component: FansDetail,
        params: {
          id: 1,
          page: ''
        }
      }
    ]
  }, /*{
    path: '/history',
    name: 'history',
    // component: ,
    meta: {
      title: 'HISTORY',
    }
  }, {
    path: '/feeds',
    name: 'feeds',
    component: Feeds,
    meta: {
      title: 'FEEDS',
    },
    children: [
      {
        path: '/feedsNews',
        name: 'feedsNews',
        component: FeedsNews,
        meta: {
          title: '뉴스',
        },
        /!*children: [{
          path: ':id',
          name : '',
          component: ,
          params: {
            id: 1
          }
        }]*!/
      }, {
        path: '/youtube',
        name: 'youtube',
        component: Youtube,
        meta: {
          title: '유튜브',
        },
        /!*children: [{
          path: ':id',
          name : '',
          component: ,
          params: {
            id: 1
          }
        }]*!/
      }, {
        path: '/facebook',
        name: 'facebook',
        component: Facebook,
        meta: {
          title: '페이스북',
        },
        /!*children: [{
          path: ':id',
          name : '',
          component: ,
          params: {
            id: 1
          }
        }]*!/
      }, {
        path: '/instagram',
        name: 'instagram',
        component: Instagram,
        meta: {
          title: '인스타그램',
        },
        /!*children: [{
          path: ':id',
          name : '',
          component: ,
          params: {
            id: 1
          }
        }]*!/
      }
    ]
  },*/ {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: rejectAuthUser
  }, {
    path: '/join',
    name: 'join',
    component: Join,
    redirect: {
      name: 'agree'
    },
    children: [
      {
        path: 'agree',
        name: 'agree',
        component: JoinAgreeBox,
      }, {
        path: 'citation',
        name: 'citation',
        component: JoinUserCitation,
      }, {
        path: 'form',
        name: 'form',
        component: JoinForm,
      }
    ]
  }, {
    path: '/findPassword',
    name: 'findPassword',
    component: FindPassword
  }, {
    path: '/findId',
    name: 'findId',
    component: FindId
  }, {
    path: '/servicePolicy',
    name: 'servicePolicy',
    component: ServicePolicy
  }, {
    path: '/privacy',
    name: 'privacy',
    component: privacy
  }, {
    path: '/myPage',
    name: 'myPageView',
    component: MyPageView,
    redirect: {
      name: 'myPage'
    },
    children: [
      {
        path: 'myPage',
        name: 'myPage',
        component: MyPage,
        beforeEnter: onlyAuthUser,
      },  {
        path: 'myInfo',
        name: 'myInfo',
        component: MyInfo,
        beforeEnter: onlyAuthUser,
      }, {
        path: 'withdraw',
        name: 'withdraw',
        component: Withdraw,
        beforeEnter: onlyAuthUser,
      // }, {
      //   path: 'contactUs',
      //   name: 'contactUs',
      //   component: ContactUs,
      //   beforeEnter: onlyAuthUser,
      // }, {
      //   path: '/contactUs/write',
      //   name: 'contactUsWrite',
      //   component: ContactUsWrite,
      //   beforeEnter: onlyAuthUser,
      }
    ]
  },
  {
    path: '/reservationTest',
    name: 'reservationTestView',
    component: ReservationTest,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.name !== from.name) {
      return { x: 0, y: 0 }
    }
  },
  routes
});

router.beforeEach(async (to, from, next) => {
  const token = JSON.parse(localStorage.getItem('token'));
  const lastActivity = JSON.parse(localStorage.getItem('lastActivity'));
  const currentTime = new Date().getTime();

  // 마지막 활동 시간이 설정한 기간(토큰 유효 1시간)을 초과했는지 확인
  if (lastActivity && (currentTime - lastActivity > 3600000)) {
    // 만료 시간을 초과했으면 로컬 스토리지에서 토큰 제거
    localStorage.removeItem('token');
    localStorage.removeItem('lastActivity');
  } else if (token && token.access) {
    // 토큰이 존재하고, 마지막 활동 시간이 만료되지 않았다면 토큰 유효성 검사
    await store.dispatch('loginTokenCheck');
  }

  await next();
});

export default router
